import apiConfig from "../../config/apiConfig";
import apiConfigWthFormData from "../../config/apiConfigWthFormData";
import { PAYMENT_TYPE, END_POINT } from "../constants";
import { setError } from "./errorAction";
import { hideLoading, showLoading } from "./loadingAction";
import { DOMAIN_APP_VIETTELMEDIA, SECRET_KEY_PAYMENT } from "../../config/config";
import CryptoJS from "crypto-js";
import { v4 as uuidv4 } from "uuid";
import { replaceNavigate } from "../../services/helpers/Helper";
import { URL } from "../../routers/constants";

export const fetchPaymentMethod = (shop_id) =>
   async (dispatch) => {
      let shopId = 0;
      if (shop_id){
         shopId = shop_id;
      }
      dispatch(showLoading());
      return apiConfig.get(END_POINT.LIST_PAYMENT_METHOD + '?shop_id=' + shopId).then((response) => {
         dispatch({
            type: PAYMENT_TYPE.FETCH,
            payload: response.data
         });
         return Promise.resolve(response);
      }).catch((error) => {
         dispatch(setError(error.message));
      }).finally(() => {
         dispatch(hideLoading());
      });
   };


export const paymentSubmit = (order_code, payment_method_id, callback) =>
   async (dispatch) => {
      const params = {
         order_code,
         payment_method_id
      }
      dispatch(showLoading());
      apiConfigWthFormData.post(END_POINT.PAYMENT_SUBMIT, params).then((response) => {
         if (callback) {
            callback();
         }
      }).catch((error) => {
         dispatch(setError(error.message));
      }).finally(() => {
         dispatch(hideLoading());
      });
   }
 
export const payUrl = (reference_code, payment_method_id, payment_method_sub_id) =>
   async (dispatch,getState) => {
      const { user } = getState();
      const secretKeyPayment = SECRET_KEY_PAYMENT;
      const transId = uuidv4();
      const signature = CryptoJS.HmacSHA1(transId + reference_code + payment_method_id, secretKeyPayment).toString();
      const params = {
         transId: transId,
         billCode: reference_code,
         paymentMethodId: payment_method_id,
         subMethodId:payment_method_sub_id,
         domain: DOMAIN_APP_VIETTELMEDIA + replaceNavigate(URL.SHOPPING_CART_PAY_RESULT),
         signature: signature,
         isRedirectLink: false
      }
      dispatch(showLoading());
      return apiConfigWthFormData.post(END_POINT.PAYMENT_PAY_URL, params).then((response) => {
         return Promise.resolve(response.data);
      }).catch((error) => {
         return Promise.reject(error);
      }).finally(() => {
         dispatch(hideLoading());
      });
   }
